module.exports = __webpack_public_path__ + "b1156ba744b52803a86b26ee7c1c9089.gif";